export default {"src":"/_next/static/media/0x0f52a51287f9b3894d73df05164d0ee2533ccbb4.e11c0fc6.svg","height":127,"width":127,"blurWidth":0,"blurHeight":0};